import { mode } from '@chakra-ui/theme-tools'
import { cardAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(cardAnatomy.keys)

const baseStyle = definePartsStyle(props => {
  return {
    container: {
      backgroundColor: `${mode('white', 'neutral.50')(props)}`,
      border: '1px',
      borderColor: `${mode(
        'blackAlpha.50',
        'whiteAlpha.200'
      )(props)} !important`,
    },
  }
})

export const Card = defineMultiStyleConfig({
  baseStyle,
})
